import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    target: String
  }

  connect() {
    this.updateErrorIcons()
    document.addEventListener('turbo:morph', this.updateErrorIcons)
    document.addEventListener('turbo:morph-element', this.updateErrorIconsIfMorphed)
  }

  disconnect() {
    document.removeEventListener('turbo:morph', this.updateErrorIcons)
    document.removeEventListener('turbo:morph-element', this.updateErrorIconsIfMorphed)
  }

  updateErrorIconsIfMorphed = (event) => {
    if (event.target.id === this.element.id) {
      this.updateErrorIcons()
    }
  }

  updateErrorIcons = () => {
    let targetFieldSet = document.getElementById(this.targetValue)?.closest('.fieldset')
    if (targetFieldSet && targetFieldSet.querySelectorAll('.is-invalid').length > 0) {
      this.element.querySelector('.alert-icon').classList.remove('d-none')
    }
  }
}
